import { FaGithub, FaLinkedinIn, FaEnvelope } from "react-icons/fa";

// Social links, edit once, updates everywhere automatically
// Used in: Homepage banner, Contact page, Footer
export const socialLinks = [
  {
    icon: FaGithub,
    url: "https://github.com/CamilleOnoda",
    name: "GitHub",
  },
  {
    icon: FaLinkedinIn,
    url: "https://linkedin.com/in/camilleonoda",
    name: "LinkedIn",
  },
  {
    icon: FaEnvelope,
    url: "mailto:info@camilleonoda.com",
    name: "Email",
  },
];
